import React from 'react';
import PropTypes from 'prop-types';
import styles from './IndustryCard.module.scss';

const IndustryCard = ({ title }) => (
  <div className={styles.card}>
    <p>{title}</p>
  </div>
);

IndustryCard.propTypes = {
  title: PropTypes.string.isRequired,
};

export default IndustryCard;
